import React from 'react';

const Spacer = ({ orientation, size }) => (
  <div
    style={{
      width: orientation === 'h' ? `${size * 8}px` : '100%',
      height: orientation === 'v' ? `${size * 8}px` : '100%',
      display: `${orientation === 'h' ? 'inline-' : ''}block`,
    }}
  />
);

Spacer.defaultProps = {
  size: 1,
  orientation: 'v',
};

export default Spacer;
